module.exports = __webpack_public_path__ + "static/img/Womens and Mens Health@2x.2d7d0492.png";